import { withI18n } from '@lingui/react'
import { shape, string } from 'prop-types'
import { compose } from 'redux'

import { PAGE_TYPE_SEARCH_RESULTS } from 'shared/consts'
import zavaLogo from 'views/assets/images/logos/logo-zava.svg'
import odsImageLarge from 'views/assets/images/misc/misc-ODS-large.png'
import odsImage from 'views/assets/images/misc/misc-ODS.svg'
import Badge from 'views/components/atoms/Badge'
import Button from 'views/components/atoms/Button'
import IconHome from 'views/components/atoms/Icon/IconHome'
import IconRedeemRecipe from 'views/components/atoms/Icon/IconRedeemRecipe'
import Image from 'views/components/atoms/Image'
import TextWithIcon from 'views/components/molecules/TextWithIcon'
import TransWithHtml from 'views/components/utils/TransWithHtml'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import { i18nType, publicRuntimeConfigType } from 'views/utils/propTypes'

import './OdsZavaModal.scss'

const renderButtonRequestText = pageType =>
  pageType === PAGE_TYPE_SEARCH_RESULTS ? (
    <TransWithHtml id="onlinedoctorservice.receiptonline.cta.text" />
  ) : (
    <TransWithHtml id="pdp.buyboxwithvariants.odsModal.button.accesstomedication" />
  )

const setHrefUrl = (pageType, indicationUrl) =>
  pageType === PAGE_TYPE_SEARCH_RESULTS ? ' ' : indicationUrl

const OdsModalContent = ({
  i18n,
  indicationUrl,
  publicRuntimeConfig: {
    pageProperties: { pageType },
  },
}) => {
  return (
    <>
      <ul className="a-list-reset l-flex@medium">
        <li className="l-flex__start">
          <div>
            <Image
              alt={i18n._('pdp.buyboxwithvariants.odsModal.image.alt')}
              src={odsImageLarge}
              srcMobile={odsImage}
              width="200"
              className="o-odsModal-Image--center"
            />
          </div>
        </li>
        <li>
          <div className="u-padding--left">
            <h2 className="a-h2">
              <TransWithHtml id="pdp.buyboxwithvariants.odsModal.header" />
            </h2>
            <div className="l-grid u-margin-small--bottom">
              <div className="l-grid__item l-col--1-of-12">
                <Badge value="1" color="blue" size="x-small" />
              </div>
              <div className="l-grid__item l-col--11-of-12">
                <h4>
                  <TransWithHtml id="pdp.buyboxwithvariants.odsModal.process.step1" />
                </h4>
              </div>
            </div>
            <div className="l-grid u-margin-small--bottom">
              <div className="l-grid__item l-col--1-of-12">
                <Badge value="2" color="blue" size="x-small" />
              </div>
              <div className="l-grid__item l-col--11-of-12">
                <h4>
                  <TransWithHtml id="pdp.buyboxwithvariants.odsModal.process.step2" />
                </h4>
              </div>
            </div>
            <div className="l-grid u-margin-small--bottom">
              <div className="l-grid__item l-col--1-of-12">
                <Badge value="3" color="blue" size="x-small" />
              </div>
              <div className="l-grid__item l-col--11-of-12">
                <h4>
                  <TransWithHtml id="pdp.buyboxwithvariants.odsModal.process.step3" />
                </h4>
              </div>
            </div>
          </div>
          <div className="u-padding--bottom">
            <Button
              id={`${pageType}-rx-zavaClick`}
              name="ods-modal-go-to-zava"
              data-clientside-hook="ods-modal-go-to-zava"
              href={setHrefUrl(pageType, indicationUrl)}
            >
              {renderButtonRequestText(pageType)}
            </Button>
          </div>
          <div className="o-odsModal-strike">
            <span className="u-color--grey">oder</span>
          </div>

          <div className="u-padding--top">
            <Button
              id={`${pageType}-rx-nearByClick`}
              style="buttonGhost"
              name="ods-find-doctor-nearby"
              data-clientside-hook="ods-modal-find-doctor-nearby"
              target="_blank"
              href="https://www.jameda.de/"
            >
              <TransWithHtml id="pdp.buyboxwithvariants.odsModal.button.localsearch" />
            </Button>
          </div>
        </li>
      </ul>
      <div className="a-box--medium a-box a-box--light u-margin-x-large--top">
        <div>
          <center>
            <img width="100" src={zavaLogo} alt="" />
          </center>
        </div>
        <div>
          <h4 className="u-padding-x-large--top">
            <TransWithHtml id="pdp.buyboxwithvariants.odsModal.zava.desc" />
          </h4>
        </div>
        <div>
          <TextWithIcon
            icon={<IconHome className="u-color--blue" />}
            alignIconToTop
          >
            <div className="u-padding-xx-small--top u-color--dark u-padding--left">
              <TransWithHtml id="pdp.buyboxwithvariants.odsModal.zava.info1" />
            </div>
          </TextWithIcon>
        </div>
        <div className="u-padding--top">
          <TextWithIcon
            icon={<IconRedeemRecipe className="u-color--blue" />}
            alignIconToTop
          >
            <div className="u-padding-xx-small--top u-color--dark u-padding--left">
              <TransWithHtml id="pdp.buyboxwithvariants.odsModal.zava.info2" />
            </div>
          </TextWithIcon>
        </div>
      </div>
    </>
  )
}

OdsModalContent.propTypes = {
  i18n: i18nType.isRequired,
  indicationUrl: string,
  publicRuntimeConfig: shape(publicRuntimeConfigType).isRequired,
}

export default compose(withShopAndRuntimeConfig, withI18n())(OdsModalContent)
